import { cn } from "@/lib/utils";

interface FormFieldProps {
  children: React.ReactNode;
  className?: string;
}

export function FormField({ children, className }: FormFieldProps) {
  return (
    <div
      className={cn(
        "space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5",
        className,
      )}
    >
      {children}
    </div>
  );
}

interface FormFieldLabelProps {
  children: React.ReactNode;
  htmlFor?: string;
  className?: string;
}

export function FormFieldLabel({ children, htmlFor, className }: FormFieldLabelProps) {
  return (
    <div>
      <label
        htmlFor={htmlFor}
        className={cn("block text-sm font-medium text-foreground sm:mt-px sm:pt-2", className)}
      >
        {children}
      </label>
    </div>
  );
}

interface FormFieldInputProps {
  children: React.ReactNode;
  className?: string;
}

export function FormFieldInput({ children, className }: FormFieldInputProps) {
  return <div className={cn("sm:col-span-2", className)}>{children}</div>;
}
